import { Resource } from './resource'
import { CommunityChannel } from './community-channel'
import { Tag } from './tag'
import { Program } from './program'

export class JourneyStep {
  type: string;
  id: number;
  label?: string;
  notification_date?: Date;
  custom_description?: string;
  custom_title?: string;
  default_description: string;
  default_title: string;
  count?: number;
  custom_buttom_text?: string;
  date?: string;
  link?: string;
  channel?: CommunityChannel;
  resources?: Resource[];
  tag?: Tag;
  program?: Program;
  image?: string;
  media_video_id?: number;
  media_video_url?: string;
}


// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/journey-editor/journey-step.ts